<template>
  <div class="question">
    <div class="title_bor">温馨提示：</div>
    <template v-if="$appSource === 3">
      <div class="item item_bor">
        {{
          $G(
            "为了高效解决您的问题，减少您可能的等待时间，建议您不妨先仔细阅读下面的热门常见问题，查询物流状态、退货退款等操作，均可登入我的订单页进行自助查看，或联系客服进行咨询。若仍无法解决您的问题，建议您在此页面下拉最下方，联系在线客服为您服务。感谢您对Milky Cloud的支持！"
          )
        }}
      </div>
    </template>
    <template v-else>
      <div class="item item_bor">
        {{
          $G(
            "为了高效解决您的问题，减少您可能的等待时间，建议您不妨先仔细阅读下面的热门常见问题，查询物流状态、退货退款等操作，均可登入我的订单页进行自助查看，或联系商家客服进行咨询。若仍无法解决您的问题，建议您在此页面下拉最下方，联系在线客服或拨打客服热线为您服务。感谢您对az全球购的支持！"
          )
        }}
      </div>
    </template>
    <div>
      <van-collapse v-model="activeNames">
        <van-collapse-item
          v-for="(item, index) in computedList"
          :key="index"
          :name="index"
        >
          <div slot="title" class="que_title">
            <img :src="item.pic" class="que_img" />
            <span class="pad">{{ item.title }}</span>
          </div>
          <div class="item_con">{{ item.con }}</div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="det_det">
      <template v-if="$appSource === 3">
        如没能解决您的问题，请联系在线客服（工作时间：周一至周五 9:00–17:00
        AEST）
      </template>
      <template v-else>
        如没能解决您的问题，请联系在线客服（工作时间：周一到周五9:00-18:00）
      </template>
    </div>
    <!-- <div class="bottom_service" @click="goService">
      <img src="@/assets/order/icon_service@2x.png" alt="" />
      <span class="ser_font">联系客服</span>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: ["0"]
    };
  },
  computed: {
    computedList() {
      if (this.$appSource === 3) {
        return [
          {
            title: "拍下的订单之后什么时候发货，一般多久可以收到货？",
            pic: require("@/assets/mine/inform/q1.png"),
            con:
              "正常情况下您的订单将在120小时内发出（除发货地法定节假日及特殊情况外）。发货之后，您可以在我的订单中可以查看发货状态。由于快递公司可能无法实时更新信息，因此您看到的发货情况可能有一定延迟。"
          },
          {
            title: "如何保障正品？",
            pic: require("@/assets/mine/inform/q2.png"),
            con: this.$G(
              "Milky Cloud承诺其销售的所有商品是“澳洲正品保障，本地直供”，为您创造一个便捷的澳洲本地购物体验，足不出户轻松购遍全澳，让您省心更放心！"
            )
          },
          {
            title: "为什么订单显示发货了，但是快递信息还没有更新？",
            pic: require("@/assets/mine/inform/q3.png"),
            con: this.$G(
              "亲～如果您查看物流跟踪信息一直停留在同一个状态，可能是物流公司还没来得及录入新信息或者物流公司更新后同步到Milky Cloud存在滞后，不会影响正常收货，您也可以先联系商家或物流公司，确认货物运送是否出现异常。"
            )
          },
          {
            title: "购买商品，为什么要求我上传身份证？",
            pic: require("@/assets/mine/inform/q4.png"),
            con: this.$G(
              "在Milky Cloud购买商品时，为保障物流准确送达及符合澳大利亚海关要求，您可能需要提供真实的收货人姓名及有效地址信息。请确保收货信息准确无误，以避免延误或清关问题。"
            )
          },
          {
            title: "如何上传身份证？",
            pic: require("@/assets/mine/inform/q5.png"),
            con: "您可以打开订单详情页面，在订单状态区域点击上传或者查看即可"
          },
          {
            title: "上传身份证时提示我收货人与身份证信息不一致怎么办？",
            pic: require("@/assets/mine/inform/q6.png"),
            con: this.$G(
              "亲～Milky Cloud商品在发货前会核对收货信息。若系统提示收货人信息有误，请检查您填写的姓名及地址是否与实际一致。如需修改，请及时联系客服协助处理；若无法更正，建议申请退款后重新下单。"
            )
          },
          {
            title: "海外商品是否有中文标签？",
            pic: require("@/assets/mine/inform/q7.png"),
            con: this.$G(
              "亲～Milky Cloud销售的商品直接来自澳洲本地品牌或授权仓，商品标签遵循澳洲当地标准，以英文标注为主。如有任何疑问，欢迎联系客服协助说明。"
            )
          }
        ];
      } else {
        return [
          {
            title: "拍下的订单之后什么时候发货，一般多久可以收到货？",
            pic: require("@/assets/mine/inform/q1.png"),
            con:
              "正常情况下您的订单将在120小时内发出（除发货地法定节假日及特殊情况外）。发货之后，您可以在我的订单中可以查看发货状态。由于快递公司可能无法实时更新信息，因此您看到的发货情况可能有一定延迟。"
          },
          {
            title: "如何保障正品？",
            pic: require("@/assets/mine/inform/q2.png"),
            con: this.$G(
              "az全球购承诺其销售的所有商品是“海外正品保障，海外直供”，为您创造一个便捷的跨境购物体验，足不出户轻松扫遍澳新，让您省心更放心！"
            )
          },
          {
            title: "为什么订单显示发货了，但是快递信息还没有更新？",
            pic: require("@/assets/mine/inform/q3.png"),
            con: this.$G(
              "亲～如果您查看物流跟踪信息一直停留在同一个状态，可能是物流公司还没来得及录入新信息或者物流公司更新后同步到az全球购存在滞后，不会影响正常收货，您也可以先联系商家或物流公司，确认货物运送是否出现异常。"
            )
          },
          {
            title: "购买商品，为什么要求我上传身份证？",
            pic: require("@/assets/mine/inform/q4.png"),
            con: this.$G(
              "您在购买海外商品时，由于国家有关政策，需要您提供收货人的真实姓名和身份证信息，用于海关清关。请注意：身份证信息必须与收货人保持一致（身份证信息上传一次即可，后续在az全球购，购物则无需再次上传）"
            )
          },
          {
            title: "如何上传身份证？",
            pic: require("@/assets/mine/inform/q5.png"),
            con: "您可以打开订单详情页面，在订单状态区域点击上传或者查看即可"
          },
          {
            title: "上传身份证时提示我收货人与身份证信息不一致怎么办？",
            pic: require("@/assets/mine/inform/q6.png"),
            con: this.$G(
              "亲～az全球购【海外仓】和【进口保税】商品根据国家法规规定需要个人买家提供身份证信息来完成海关清关流程，身份证信息必须和收货人信息保持一致，若您填写的收货人姓名有误，将会影响海关正常清关，如遇此情况，建议您可尝试联系客户沟通协助您进行修改，若客服无法操作更改收货人信息，建议您此笔订单申请退款重拍。"
            )
          },
          {
            title: "海外商品是否有中文标签？",
            pic: require("@/assets/mine/inform/q7.png"),
            con: this.$G(
              "亲～az全球购海外商品是通过跨境购物方式直接送达您手中，和您在国外购买的商品是一样的没有中文标签哦。"
            )
          }
        ];
      }
    }
  },
  methods: {
    backClick() {
      this.$router.back();
    },
    goService() {
      // this.$router.push('/mine/message')
    }
  }
};
</script>

<style scoped>
.question {
  background: #fff;
  font-size: 14px;
  font-weight: 400;
  color: #666;
  line-height: 22px;
  padding: 15px 0;
  border-top: 1px solid #eee;
}
.item {
  padding: 0 15px 10px;
  text-indent: 25px;
}
.title_bor {
  padding: 0 15px 10px;
}
.item_bor {
  padding-bottom: 20px;
  /* border-bottom: 1px solid #eee; */
}
.item_blod {
  font-weight: 500;
}
.que_img {
  width: 25px;
}
.que_title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(34, 34, 34, 1);
  line-height: 22px;
}
.pad {
  margin-left: 15px;
  display: inline-block;
  width: 80%;
}
.item_con {
  padding-left: 45px;
  font-size: 14px;
  color: #666;
}
.det_det {
  font-size: 14px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 22px;
  padding: 20px 10px 0;
  /* background: #f2f2f2; */
}
.bottom_service {
  font-size: 18px;
  font-weight: 400;
  color: rgba(221, 145, 50, 1);
  line-height: 52px;
  margin: 0 auto;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
}
.bottom_service img {
  width: 24px;
  margin-top: 15px;
  vertical-align: middle;
}
.ser_font {
  vertical-align: middle;
}
</style>
